import React from 'react';
import { format } from 'date-fns';
import { Clock } from 'lucide-react';
import { Calendar } from '../ui/calendar';
import { Input } from '../ui/input';

function parts(iso) {
  if (!iso) return { date: undefined, time: '12:00' };
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { date: undefined, time: '12:00' };
  return { date: d, time: format(d, 'HH:mm') };
}

function combine(date, time) {
  const [h, m] = (time || '00:00').split(':').map(Number);
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), h || 0, m || 0, 0, 0);
  return d.toISOString();
}

export function tomorrowIso() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString();
}

// Inline calendar + time-of-day. Renders inside dialogs without popovers so it never fights the modal layer.
export function DateTimePicker({ value, onChange, minDate, maxDate, testId = 'datetime' }) {
  const { date, time } = parts(value);
  function disabled(d) {
    const day = format(d, 'yyyy-MM-dd');
    if (minDate && day < minDate.slice(0, 10)) return true;
    if (maxDate && day > maxDate.slice(0, 10)) return true;
    return false;
  }
  return (
    <div className="grid sm:grid-cols-[auto_1fr] gap-4 items-start" data-testid={testId}>
      <div className="border border-gray-200 rounded-sm bg-white">
        <Calendar mode="single" selected={date} defaultMonth={date || (minDate ? new Date(minDate) : undefined)} onSelect={function (d) { if (d) onChange(combine(d, time)); }} disabled={disabled} className="p-2" data-testid={testId + '-calendar'} />
      </div>
      <div className="space-y-3">
        <div>
          <p className="text-xs uppercase tracking-[0.08em] text-gray-500 mb-1">Selected</p>
          <p className="sv-mono text-ink" data-testid={testId + '-selected'}>{date ? format(date, 'EEE dd MMM yyyy') : 'Pick a date'}{date ? ' · ' + time : ''}</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.08em] text-gray-500 mb-1">Time (local)</p>
          <div className="relative">
            <Input type="time" value={time} onChange={function (e) { if (date) onChange(combine(date, e.target.value)); }} disabled={!date} className="h-10 rounded-sm sv-mono pl-9 w-40" data-testid={testId + '-time'} />
            <Clock className="h-4 w-4 text-gray-500 absolute left-3 top-1/2 -translate-y-1/2" />
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.08em] text-gray-500 mb-1">Or type a date</p>
          <Input type="date" value={date ? format(date, 'yyyy-MM-dd') : ''} min={minDate ? minDate.slice(0, 10) : undefined} max={maxDate ? maxDate.slice(0, 10) : undefined} onChange={function (e) { if (e.target.value) onChange(combine(new Date(e.target.value + 'T00:00:00'), time)); }} className="h-10 rounded-sm sv-mono w-44" data-testid={testId + '-date-input'} />
        </div>
      </div>
    </div>
  );
}
